import BillingsPlanEntryTaxiDriverRecalculateRequest, {
  BillingsPlanEntryTaxiDriverRecalculateRequestBillingNode,
  BillingsPlanEntryTaxiDriverRecalculateRequestBonusContribution,
  BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverRecalculateRequestContribution,
  BillingsPlanEntryTaxiDriverRecalculateRequestContributionType,
  BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContribution,
  BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionWrongRoute,
} from "../../../../../api/raily/billings/plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate.request";
import BillingsPlanEntryTaxiDriverRecalculateParams, {
  BillingsPlanEntryTaxiDriverRecalculateParamsBillingNode,
  BillingsPlanEntryTaxiDriverRecalculateParamsBonusContribution,
  BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverRecalculateParamsContribution,
  BillingsPlanEntryTaxiDriverRecalculateParamsContributionType,
  BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContribution,
  BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionWrongRoute,
} from "./billings-plan-entry-taxi-driver-recalculate-params";

const createBillingBonusContributionFavorableDistance = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionFavorableDistance,
): BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionFavorableDistance => {
  return {
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.BONUS_FAVORABLE_DISTANCE,
  };
};

const createBillingBonusContributionOther = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionOther,
): BillingsPlanEntryTaxiDriverRecalculateRequestBonusContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.BONUS_OTHER,
  };
};

const createBillingBonusContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsBonusContribution,
): BillingsPlanEntryTaxiDriverRecalculateRequestBonusContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BONUS_FAVORABLE_DISTANCE:
      return createBillingBonusContributionFavorableDistance(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionFavorableDistance,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BONUS_OTHER:
      return createBillingBonusContributionOther(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsBonusContributionOther,
      );
  }
};

const createBillingPenaltyOther = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionOther,
): BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_OTHER,
  };
};

const createBillingPenaltyIncompatibleCar = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionIncompatibleCar,
): BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionIncompatibleCar => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_INCOMPATIBLE_CAR,
  };
};

const createBillingPenaltyBeingLate = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionBeingLate,
): BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionBeingLate => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_BEING_LATE,
  };
};

const createBillingPenaltyWrongRoute = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionWrongRoute,
): BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContributionWrongRoute => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.PENALTY_WRONG_ROUTE,
  };
};

const createBillingPenaltyContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContribution,
): BillingsPlanEntryTaxiDriverRecalculateRequestPenaltyContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_BEING_LATE:
      return createBillingPenaltyBeingLate(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionBeingLate,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_OTHER:
      return createBillingPenaltyOther(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionOther,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
      return createBillingPenaltyIncompatibleCar(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionIncompatibleCar,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyWrongRoute(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContributionWrongRoute,
      );
  }
};

const createBillingContractCorrectionContributionBaseAmountExternalTaxi = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionBaseAmountExternalTaxi,
): BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionBaseAmountExternalTaxi => {
  return {
    amount: contribution.amount,
    distance: contribution.distance,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.BASE_AMOUNT_EXTERNAL_TAXI,
  };
};

const createBillingContractCorrectionContributionOtherRate = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionOtherRate,
): BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContributionOtherRate => {
  return {
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverRecalculateRequestContributionType.CONTRACT_CORRECTION_RATE,
  };
};

const createBillingContractCorrectionContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContribution,
): BillingsPlanEntryTaxiDriverRecalculateRequestContractCorrectionContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
      return createBillingContractCorrectionContributionBaseAmountExternalTaxi(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionBaseAmountExternalTaxi,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContributionOtherRate(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContributionOtherRate,
      );
  }
};

const createBillingContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateParamsContribution,
): BillingsPlanEntryTaxiDriverRecalculateRequestContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BONUS_FAVORABLE_DISTANCE:
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BONUS_OTHER:
      return createBillingBonusContribution(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsBonusContribution,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_BEING_LATE:
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_OTHER:
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyContribution(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsPenaltyContribution,
      );
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
    case BillingsPlanEntryTaxiDriverRecalculateParamsContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContribution(
        contribution as BillingsPlanEntryTaxiDriverRecalculateParamsContractCorrectionContribution,
      );
  }
};

const createBillingContributions = (
  contributions: BillingsPlanEntryTaxiDriverRecalculateParamsContribution[],
): BillingsPlanEntryTaxiDriverRecalculateRequestContribution[] => {
  return contributions.map(createBillingContribution);
};

const createBillingNode = (
  node: BillingsPlanEntryTaxiDriverRecalculateParamsBillingNode,
): BillingsPlanEntryTaxiDriverRecalculateRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsPlanEntryTaxiDriverRecalculateParamsBillingNode[],
): BillingsPlanEntryTaxiDriverRecalculateRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  params: BillingsPlanEntryTaxiDriverRecalculateParams,
): BillingsPlanEntryTaxiDriverRecalculateRequest => {
  return {
    billingContributions: createBillingContributions(
      params.billingContributions,
    ),
    billingNodes: createBillingNodes(params.billingNodes),
    planEntryId: params.planEntryId,
  };
};

const billingsPlanEntryTaxiDriverRecalculateParamsFactory = {
  create,
};

export default billingsPlanEntryTaxiDriverRecalculateParamsFactory;
